// extracted by mini-css-extract-plugin
module.exports = {"button":"AvatarHolding_button__3HB9v","full-width-avatar":"AvatarHolding_full-width-avatar__o2msG","card":"AvatarHolding_card__38wk_","avatar":"AvatarHolding_avatar__4BXP2"};